module.exports = __webpack_public_path__ + "static/media/indik-8.9a732229.png";